
/**
 * on (EventHandler)
 * @param  {Any} ...args
 * @return {Function}
 */
function modelpool(...args) {
	return function(target, name, descriptor) {

	}
}

export {
	modelpool
};
